import styled from '@emotion/styled';

export const SupersetDisplay = styled('div')(() => ({
  width: '100%',
  height: '100%',
  iframe: {
     width: '100%',
     height: '100%',
    },
}));